import { VStack } from "@/components/ui/vstack";
import i18n from "i18n-js";
import React from 'react';
import Footer from "../../components/basic/Footer";
import Header from "../../components/basic/Header";
import BackGesture from "../../containers/BackGesture";
import Account from "../../components/common/Account"
import { switchScreen } from '../../hooks/navigate';

export default function AccountSettings({ route, navigation }) {
    const { isEdit, isAnonymous } = route.params

    const actions = [
        isEdit ? { icon: '' } : { icon: 'keyboard-arrow-left', text: 'footer.back', component: 'BACK' },
        { icon: 'home', text: 'footer.home', component: 'Home' },
        isEdit ? { icon: 'check', text: 'footer.finish', component: 'accountSettings', params: { isEdit: false, isAnonymous: isAnonymous } } : { icon: 'edit', text: 'footer.edit', component: 'accountSettings', params: { isEdit: true, isAnonymous: isAnonymous } }
    ]

    const toggle = () => {
        switchScreen(navigation, 'accountSettings', { isEdit: false, isAnonymous: !isAnonymous })
    }

    return (
        <BackGesture navigation={navigation}>
            <VStack className="flex-1 bg-secondary-50">
                <Header navigation={navigation} options={{ title: i18n.t('sideNavigationDrawer.accountSettings') }} />
                <Account isEdit={isEdit} isAnonymous={isAnonymous} />
                <Footer navigation={navigation} button={isEdit ? null : { action: toggle, info: isAnonymous ? 'accountSettings.gotoPersonal' : 'accountSettings.gotoPublic' }} actions={actions} />
            </VStack>
        </BackGesture>
    );
}
